var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "emd-tabbar jsTabbar _bordered _bordered" }, [
        _c("ul", { staticClass: "emd-tabbar__list" }, [
          _c("li", { staticClass: "emd-tabbar__item" }, [
            _c(
              "a",
              {
                staticClass: "emd-tabbar__link",
                class: { _active: _vm.tabActive === "info" },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("info")
                  },
                },
              },
              [
                _c("span", { staticClass: "emd-text" }, [
                  _vm._v(_vm._s(_vm.$t("webhook.detail.tab-info"))),
                ]),
              ]
            ),
          ]),
          _c("li", { staticClass: "emd-tabbar__item" }, [
            _c(
              "a",
              {
                staticClass: "emd-tabbar__link",
                class: { _active: _vm.tabActive === "request" },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("request")
                  },
                },
              },
              [
                _c("span", { staticClass: "emd-text" }, [
                  _vm._v(_vm._s(_vm.$t("webhook.detail.tab-request"))),
                ]),
              ]
            ),
          ]),
          _c("li", { staticClass: "emd-tabbar__item" }, [
            _c(
              "a",
              {
                staticClass: "emd-tabbar__link",
                class: { _active: _vm.tabActive === "response" },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("response")
                  },
                },
              },
              [
                _c("span", { staticClass: "emd-text" }, [
                  _vm._v(_vm._s(_vm.$t("webhook.detail.tab-response"))),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm.tabActive === "info" ? _c("webhook-info") : _vm._e(),
      _vm.tabActive === "request" ? _c("webhook-request") : _vm._e(),
      _vm.tabActive === "response" ? _c("webhook-response") : _vm._e(),
      _c("last-log"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }